module.exports = __webpack_public_path__ + "img/modern-house-1.ac4d9e14.jpg";